<template>
  <div
    id="sidenav-collapse-main"
    class="collapse navbar-collapse w-auto h-auto h-100"
  >
    <ul class="navbar-nav">
      <li class="mt-3 nav-item">
        <h6
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="$store.state.isRTL ? 'me-4' : 'ms-2'"
        >
          主菜单
        </h6>
      </li>

      <li class="nav-item">
        <router-link class="nav-link" :to="{ name: '仪表盘' }">
          <div class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center">
            <i class="ni ni-chart-pie-35 text-primary text-sm opacity-10"></i>
          </div>
          <span class="nav-link-text ms-1">仪表盘</span>
        </router-link>
      </li>

      <li class="nav-item">
        <router-link class="nav-link" :to="{ name: '数据报表' }">
          <div class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center">
            <i class="ni ni-align-left-2 text-info text-sm opacity-10"></i>
          </div>
          <span class="nav-link-text ms-1">数据报表</span>
        </router-link>
      </li>

      <li v-if="hasPerm('website:manage') || hasPerm('user:manage') || hasPerm('role:manage')" class="mt-3 nav-item">
        <h6
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="$store.state.isRTL ? 'me-4' : 'ms-2'"
        >
          账号权限
        </h6>
      </li>

      <li v-if="hasPerm('website:manage')" class="nav-item">
        <router-link class="nav-link" :to="{ name: '网站管理' }">
          <div class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center">
            <i class="ni ni-world-2 text-success text-sm opacity-10"></i>
          </div>
          <span class="nav-link-text ms-1">网站管理</span>
        </router-link>
      </li>

      <li v-if="hasPerm('user:manage')" class="nav-item">
        <router-link class="nav-link" :to="{ name: '用户管理' }">
          <div class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center">
            <i class="ni ni-single-02 text-warning text-sm opacity-10"></i>
          </div>
          <span class="nav-link-text ms-1">用户管理</span>
        </router-link>
      </li>

      <li v-if="hasPerm('role:manage')" class="nav-item">
        <router-link class="nav-link" :to="{ name: '角色管理' }">
          <div class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center">
            <i class="ni ni-key-25 text-danger text-sm opacity-10"></i>
          </div>
          <span class="nav-link-text ms-1">角色管理</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "SidenavList",
  computed: {
    perms() {
      return JSON.parse(localStorage.getItem("perms") || "[]");
    },
  },
  methods: {
    hasPerm(p) {
      return this.perms.includes(p);
    },
  },
};
</script>
